import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Spinner } from "react-bootstrap";
import { FaFileExport, FaPrint, FaFilter, FaTrash,FaSearch } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import api from "../services/api";

const WorkAllotmentReport = () => {
  const [search, setSearch] = useState("");
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
    const [workerNames, setWorkerNames] = useState([]);
  
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    // transactionType: "all",
     worker: "all"
    // name: ""
  });

  useEffect(() => {
    fetchOrders();
  }, []);

// Delete handler
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this work allotment?")) {
      setReports(reports.filter((item) => item.id !== id));
    }

    try {
      const response = await api.post("/return_allotment_delete.php", { id });

      if (response.data.head.code === 200) {
        // Remove from local state
        setReports(reports.filter((p) => p.id !== id));
        alert("deleted successfully!");
      } else {
        alert("Failed to delete: " + response.data.head.msg);
      }
    } catch (err) {
      console.error("Error deleting:", err);
      alert("Failed to delete. Please try again.");
    }
  };

  const fetchOrders = async () => {
    try {
      setLoading(true);
      setError(null);

       const workerResponse = await api.post("/job_worker_list.php", {});
      if (workerResponse.data.head.code === 200) {
        setWorkerNames(workerResponse.data.body);
      }
      
      const response = await api.post("/work_allotment_report_list.php", {});
      
      if (response.data.head.code === 200) {
        setReports(response.data.body);
      } else if (response.data.head.code === 606) {
        setReports([]);
      } else {
        setError(response.data.head.msg || "Failed to fetch orders");
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      setError("Failed to load orders. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  // Simulate loading data
  useEffect(() => {
    // Simulate API call delay
    const timer = setTimeout(() => {
      // setReports(dummyReports);
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const applyFilters = () => {
    setLoading(true);
    // Simulate filter processing
    setTimeout(() => {
      // In real implementation, this would filter the data
      // For now, we'll just show all data
      setLoading(false);
    }, 300);
  };

  const resetFilters = () => {
    setFilters({
      startDate: "",
      endDate: "",
      transactionType: "all",
      name: ""
    });
    setSearch("");
  };

  const exportToCSV = () => {
    // Create CSV content
    const headers = ["Date", "Opening Balance", "Name", "Product", "Receipt", "Issue", "CB", "Amount", "Remarks"];
    const csvContent = [
      headers.join(","),
      ...reports.map(r => [
        r.date,
        r.opening_balance,
        r.name,
        r.product,
        r.receipt,
        r.issue,
        r.closing_balance,
        r.amount,
        `"${r.remarks}"`
      ].join(","))
    ].join("\n");

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `workallotment-report-${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    alert("CSV file downloaded successfully!");
  };

  const printReport = () => {
    const printContent = document.querySelector('.table-pagination-content').innerHTML;
    const originalContent = document.body.innerHTML;
    
    document.body.innerHTML = `
      <html>
        <head>
          <title>Work Allotment Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; }
            .text-success { color: green; }
            .text-danger { color: red; }
            .total-row { font-weight: bold; background-color: #f5f5f5; }
            h1 { text-align: center; margin-bottom: 20px; }
            .print-date { text-align: right; margin-bottom: 20px; }
          </style>
        </head>
        <body>
          <h1>Work Allotment Report</h1>
          <div class="print-date">Printed on: ${new Date().toLocaleDateString()}</div>
          ${printContent}
          <script>
            window.onload = function() {
              window.print();
              setTimeout(function() {
                window.close();
              }, 100);
            }
          </script>
        </body>
      </html>
    `;
  };

  // Filter reports based on search and filters
  const parseDDMMYYYY = (dateStr) => {
  if (!dateStr) return null;
  const [day, month, year] = dateStr.split("-");
  return new Date(year, month - 1, day);
};

const parseYYYYMMDD = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split("-");
  return new Date(year, month - 1, day);
};
const filteredReports = reports.filter((report) => {
  // 👷 Worker filter
  const matchesWorker =
    filters.worker === "all" ||
    report.worker === filters.worker;

  // 📅 Date filter
  const reportDate = parseDDMMYYYY(report.return_date);
  const from = filters.startDate ? parseYYYYMMDD(filters.startDate) : null;
  const to = filters.endDate ? parseYYYYMMDD(filters.endDate) : null;

  if (to) to.setHours(23, 59, 59, 999);

  const matchesDate =
    (!from || reportDate >= from) &&
    (!to || reportDate <= to);

  return matchesWorker && matchesDate;
});




  // Calculate totals
 const totals = filteredReports.reduce(
  (acc, report) => {
    acc.amount_per_return += Number(report.amount_per_return || 0);
    return acc;
  },
  { amount_per_return: 0 }
);
const formatAmount = (value) =>
  Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });


  // Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentReports,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredReports, 10);

  if (loading) {
    return (
      <Container fluid className="outer-container my-3">
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading work allotment report...</p>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container fluid className="outer-container my-3">
        <div className="alert alert-danger" role="alert">
          {error}
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={() => setError(null)}>
            Retry
          </button>
        </div>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Work Allotment Report</h2>
      
      {/* Filters Section */}
      <div className="filter-section mb-3 p-3 bg-light rounded shadow-sm">
        <Row className="align-items-center mb-2">
          <Col>
            <h5 className="mb-0">
              <FaFilter className="me-2" />
              Filters
            </h5>
          </Col>
        </Row>
        
        <Row className="g-2">
          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
              />
            </Form.Group>
          </Col>
          
          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
              />
            </Form.Group>
          </Col>
          {/* <Col xs={12} md={6} lg={6} className="mb-2 mb-md-0">
          <div className="position-relative">
            <Form.Label>Search</Form.Label>
            <Form.Control
              placeholder="Search by Product Name"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Escape') setSearch("");
              }}
            />
              </div>
            </Col> */}
            <Col xs={12} md={6} lg={6}>
  <Form.Group>
    <Form.Label>Worker</Form.Label>
    <Form.Select
  name="worker"
  value={filters.worker}
  onChange={handleFilterChange}
>
  <option value="all">All Workers</option>
  {workerNames.map((worker, idx) => (
    <option key={idx} value={worker.name}>
      {worker.name}
    </option>
  ))}
</Form.Select>

  </Form.Group>
</Col>

          
        </Row>
      </div>

      
      {/* Table Section */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <Table bordered responsive className="table-striped customer-table">
            <thead className="table-dark">
              <tr>
                <th>S.No</th>
                <th>Rtn Date</th>
                <th>Worker</th>
                <th>Customer</th>
                <th>Raw Prod.Name</th>
                <th>Fini.Prod.Name</th>
                <th>Rtn Qty</th>
                <th>Amount (₹)</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {currentReports.map((report, index) => (
                <tr key={report.id}>
                  <td>{indexOfFirstItem + index + 1}</td>
                  <td className="text-primary fw-bold">
                    {report.return_date}
                  </td>
                  <td className="text-primary fw-bold">
                    {report.worker}
                  </td>
                  <td className="text-primary fw-bold">
                    {report.customer}
                  </td>
                  <td className="text-primary fw-bold">
                    {report.raw_name}
                  </td>
                  <td className="text-primary fw-bold">
                    {report.finished_name}
                  </td>
                  <td className="text-primary fw-bold">
                    {report.return_qty}
                  </td>
                  <td className="text-primary fw-bold text-end">
                    ₹{report.amount_per_return}
                  </td>
                  <td>
                  <div className="action-icons">
                  
                    <FaTrash
                      className="delete-icon"
                      title="Delete"
                      onClick={() => handleDelete(report.id)}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </td>
                </tr>
              ))}
              {currentReports.length === 0 && (
                <tr>
                  <td colSpan="9" className="text-center py-4">
                    <div className="text-muted">
                      <FaSearch className="mb-2" size={24} />
                      <p className="mb-0">
                        {search || Object.values(filters).some(f => f) 
                          ? "No reports found matching your criteria" 
                          : "No reports available"}
                      </p>
                      <button 
                        className="btn btn-sm btn-outline-primary mt-2"
                        onClick={resetFilters}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
            {currentReports.length > 0 && (
  <tfoot className="table-warning">
    <tr>
      <td colSpan="7" className="text-end fw-bold">
        Total Amount :
      </td>
      <td className="text-end fw-bold text-success">
        ₹ {formatAmount(totals.amount_per_return)}
      </td>
      <td></td>

    </tr>
  </tfoot>
)}

          </Table>
        </div>
      </div>

      {/* Statistics */}
      {currentReports.length > 0 && (
        <Row className="mt-3">
          <Col>
            <div className="bg-light p-3 rounded">
              <h6>Report Statistics:</h6>
              <div className="d-flex flex-wrap gap-3">
                <div className="stat-item">
                  <span className="text-muted">Total Records:</span>
                  <strong className="ms-2">{filteredReports.length}</strong>
                </div>
                {/* <div className="stat-item">
                  <span className="text-muted">Receipt Transactions:</span>
                  <strong className="ms-2 text-success">
                    {filteredReports.filter(r => r.transaction_type === 'receipt').length}
                  </strong>
                </div>
                <div className="stat-item">
                  <span className="text-muted">Issue Transactions:</span>
                  <strong className="ms-2 text-danger">
                    {filteredReports.filter(r => r.transaction_type === 'issue').length}
                  </strong>
                </div>
                <div className="stat-item">
                  <span className="text-muted">Date Range:</span>
                  <strong className="ms-2">
                    {filteredReports.length > 0 
                      ? `${new Date(filteredReports[0].date).toLocaleDateString()} - ${new Date(filteredReports[filteredReports.length - 1].date).toLocaleDateString()}`
                      : 'N/A'}
                  </strong>
                </div> */}
              </div>
            </div>
          </Col>
        </Row>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </Container>
  );
};

export default WorkAllotmentReport;